import { render, staticRenderFns } from "./OrcidAuthor.vue?vue&type=template&id=60094148&scoped=true&"
import script from "./OrcidAuthor.vue?vue&type=script&lang=js&"
export * from "./OrcidAuthor.vue?vue&type=script&lang=js&"
import style0 from "./OrcidAuthor.vue?vue&type=style&index=0&id=60094148&lang=scss&scoped=true&"
import style1 from "./OrcidAuthor.vue?vue&type=style&index=1&id=60094148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60094148",
  null
  
)

export default component.exports